const formatCalories = (calories: number) => {
  const language = localStorage.getItem('i18nextLng') || 'en-US';

  return Intl.NumberFormat(language, {
    style: 'decimal',
    useGrouping: true,
    maximumFractionDigits: 0,
  }).format(calories);
};

export { formatCalories };
